import { gate } from 'hub-http/gates';
import { useDetailsPageContext } from 'marketplace-ui-common/context/DetailsPageContext';
import { useGetAppReleaseHistoryQuery as useGetAppReleaseHistoryAppQuery } from '../../__generated__/chirp/com/hubspot/marketplace/listing/details/rpc/MarketplaceListingDetailsRpc-app.hooks';
import { useGetAppReleaseHistoryQuery as useGetAppReleaseHistoryPublicQuery } from '../../__generated__/chirp/com/hubspot/marketplace/listing/details/rpc/MarketplaceListingDetailsRpc.hooks';
export function useAppReleaseHistory({
  appContext,
  slug,
  skip
}) {
  var _userInfo$gates;
  const {
    userInfo
  } = useDetailsPageContext();
  const isUngatedForReleaseManagement = userInfo === null || userInfo === void 0 || (_userInfo$gates = userInfo.gates) === null || _userInfo$gates === void 0 ? void 0 : _userInfo$gates.includes(gate('Marketplace::ReleaseManagement'));
  const isPublic = appContext === 'public';
  const shouldSkip = skip || !isUngatedForReleaseManagement;
  const {
    data: publicData
  } = useGetAppReleaseHistoryPublicQuery({
    variables: {
      slug
    },
    skip: !isPublic || shouldSkip
  });
  const {
    data: appData
  } = useGetAppReleaseHistoryAppQuery({
    variables: {
      slug
    },
    skip: isPublic || shouldSkip
  });
  return appData || publicData;
}